import {
    Drawer,
    DrawerBody,
    DrawerContent,
    Stack,
    useDisclosure,
    Icon,
    Button,
    DrawerOverlay,
    DrawerHeader,
    CloseButton,
    Text,
    Flex,
    Divider,
} from '@chakra-ui/react'
import { useLocation } from 'react-router-dom';
import { useEffect, useContext } from "react";
import { FiMenu } from 'react-icons/fi';
import PropTypes from "prop-types";
import { NavButton } from './NavButton';
import { FeedbackButton } from './FeedbackButton';
import { PwaInstall } from '../installPwa/PwaInstall';
import { PwaInstallPrompt } from '../../App';
import { UnitSystemToggle } from './components/UnitSystemToggle';
import { Link } from 'react-router-dom';

const MobileDrawer = (props) => {
    const { links } = props
    const { isOpen, onToggle, onClose } = useDisclosure();
    const location = useLocation();
    const PwaInstallPromptContext = useContext(PwaInstallPrompt);

    useEffect(() => {
        onClose()
    }, [location, onClose]);

    return (
        <div className='MobileDrawer'>
            <Button onClick={onToggle} aria-label={isOpen ? 'Open menu' : 'Close menu'} bg="teal.500" color="white" _hover={{ bg: 'teal.500' }}>
                <Icon as={FiMenu} color="white" boxSize={5} mr={1} />
                Menu
            </Button>
            <Drawer placement="right" isOpen={isOpen} onClose={onClose} sx={{ top: 72 }}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerHeader>
                        <Flex justifyContent="space-between" alignItems="center">
                            <Text fontSize={18} fontWeight={700}>Menu</Text>
                            <CloseButton onClick={onClose} />
                        </Flex>
                    </DrawerHeader>
                    <DrawerBody p="4">
                        <Stack spacing="1">
                            {links.map((link, index) => (
                                <div key={index}>
                                    <NavButton title={link.title} path={link.path} color='black' />
                                    <Divider />
                                </div>
                            ))}
                            {(PwaInstallPromptContext || !window.navigator.standalone) && // Checks if Pwa is installed
                                <>
                                    <PwaInstall />
                                    <Divider />
                                </>}
                            <FeedbackButton closeMenuDrawer={onClose} />
                        </Stack>
                        <UnitSystemToggle />
                        <Link to={'/privacy-policy'} style={{ position: 'absolute', fontSize: 15, bottom: 24, right: 24, opacity: 0.5 }}>Privacy Policy</Link>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </div>
    )
}

MobileDrawer.propTypes = {
    links: PropTypes.array,
}

MobileDrawer.defaultProps = {
    links: [],
}

export { MobileDrawer }
